module.exports = __webpack_public_path__ + "static/p13-a925479d54648253eb43c013bcb441ad.jpg";